<script>
import baseMixin from '@/mixins/baseMixin'
import BookingPendingApprovalsList from '@/components/booking/pendingApprovals/booking-pending-approvals-list.vue'
import { mapGetters, mapActions } from 'vuex'
import EmptyStateBlock from '@/components/general/empty-state-block.vue'
import SideDrawerDialog from '@/components/general/side-drawer-dialog.vue'
import BookingDetailsContent from '../details/booking-details-content.vue'
import BookingPendingApprovalsDetailsDialogHeader from './booking-pending-approvals-details-dialog-header.vue'

export default {
  name: 'BookingPendingApprovalsContainer',
  components: {
    BookingPendingApprovalsList,
    SideDrawerDialog,
    BookingPendingApprovalsDetailsDialogHeader,
    BookingDetailsContent,
    EmptyStateBlock,
  },
  mixins: [baseMixin],
  data: () => {
    return {
      activeBookingId: null,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingFlyout: 'bookingApprovals/isLoadingFlyout',
      activeBooking: 'bookingApprovals/activeBooking',
      flyoutHasError: 'bookingApprovals/flyoutHasError',
      showFlyout: 'bookingApprovals/showFlyout',
      showDetailsContent: 'bookingApprovals/showDetailsContent',
    }),
  },
  methods: {
    ...mapActions({
      resetFlyout: 'bookingApprovals/resetFlyout',
      openFlyout: 'bookingApprovals/openFlyout',
      setFlyout: 'bookingApprovals/setFlyout',
      loadApprovalDetails: 'bookingApprovals/loadApprovalDetails',
      submitPendingApproval: 'bookingApprovals/submitPendingApproval',
    }),
    async closeFlyout() {
      this.activeBookingId = null
      await this.resetFlyout()
    },
    async loadBookingDetails() {
      await this.setFlyout({
        key: 'error',
        value: false,
      })
      await this.openFlyout()
      const { isSuccess, data } = await this.loadApprovalDetails(
        this.activeBookingId
      )

      if (!isSuccess) {
        return await this.setFlyout({
          key: 'error',
          value: true,
        })
      }

      await this.setFlyout({
        key: 'booking',
        value: data,
      })
    },
    async handleTableRowClick(item) {
      this.activeBookingId = item.id
      await this.loadBookingDetails()
    },
    async loadApprovalsList() {
      await this.$refs.pendingApprovalsTable.loadApprovals()
    },
    async submitPendingApprovalResponse(payload) {
      const { isSuccess } = await this.submitPendingApproval(payload)

      if (!isSuccess) return

      this.closeFlyout()
      await this.loadApprovalsList()
    },
    async handleEvent(payload) {
      switch (payload.event) {
        case 'submitPendingApproval':
          return await this.submitPendingApprovalResponse(payload.value)
        default:
          throw new Error(`Unhandled event: ${payload.event}`)
      }
    },
  },
}
</script>

<template>
  <div>
    <BookingPendingApprovalsList
      ref="pendingApprovalsTable"
      @loadBookingDetails="handleTableRowClick"
    />

    <SideDrawerDialog
      :show="showFlyout"
      :xl="5"
      :lg="6"
      :md="10"
      @closeDialog="closeFlyout"
    >
      <template v-slot:header>
        <BookingPendingApprovalsDetailsDialogHeader @close="closeFlyout" />
      </template>

      <div
        v-if="isLoadingFlyout"
        class="w-full h-100 d-flex justify-center align-center"
      >
        <v-progress-circular size="60" color="primary" indeterminate />
      </div>

      <EmptyStateBlock
        v-else-if="flyoutHasError"
        :title="$t('booking.details.loading.failure.title')"
        :description="$t('booking.details.loading.failure.description')"
        border
      >
        <template v-slot:button>
          <div class="mt-4">
            <v-btn color="primary" depressed large @click="loadBookingDetails">
              <v-icon left> mdi-refresh </v-icon>
              {{ $t('general.retry') }}
            </v-btn>
          </div>
        </template>
      </EmptyStateBlock>

      <BookingDetailsContent
        v-else-if="showDetailsContent"
        :booking="activeBooking"
        @actionEvent="handleEvent"
      />
      <template v-slot:actions> </template>
    </SideDrawerDialog>
  </div>
</template>
